import ApiService from '@/services/api.service';

const LetterTemplatesService = {
    getAll(parameter) {
        const requestData = {
            method: 'get',
            url: '/LetterTemplates/',
            headers: {},
            params: {
                SearchCriteria: parameter.SearchCriteria,
                PageSize: parameter.PageSize,
                PageNumber: parameter.PageNumber
            }
        };
        return ApiService.customRequest(requestData);
    },

    getLookUp(parameters) {
        var _Url = '/LetterTemplates/LookUpValue/';
        const requestData = {
            method: 'get',
            url: _Url,
            params: parameters
        };
        return ApiService.customRequest(requestData);
    },

    getMedLabelPdf(code, codeList) {
        return ApiService.get(
            `/LetterTemplates/CreateMedLabelPdf?Code=${code}&CodeList=${codeList}&ForQzTray=true`
        );
    },

    getHasPatientWristbandSetup() {
        return ApiService.get(`/LetterTemplates/HasPatientWristbandSetup`);
    },

    getLabelSettings() {
        return ApiService.get(`/LetterTemplates/LabelSettings`);
    },

    getPatientPortalLookup() {
        return ApiService.get(`/LetterTemplates/PatientPortalLookup`);
    }
};

export default LetterTemplatesService;
